export const getLeadSourceImageUrl = (imagePath) => {
  if (!imagePath) return null;

  if (imagePath.startsWith('http://') || imagePath.startsWith('https://')) {
    return imagePath;
  }

  const baseURL = process.env.REACT_APP_SALES_API_URL || 'https://sales-dev-api.simplego.am/';

  const normalizedBaseURL = baseURL.endsWith('/') ? baseURL : `${baseURL}/`;

  const cleanPath = imagePath.startsWith('/') ? imagePath.slice(1) : imagePath;

  return `${normalizedBaseURL}${cleanPath}`;
};
